import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

const ONE_MINUTE = 60000;
const ONE_HOUR = ONE_MINUTE * 60;

const appIdDev = '1:730296716531:web:901ddfdf488eeafef9bb86';
const appIdAcc = '1:730296716531:web:f1e3a2f804b12a20f9bb86';
const appIdProd = '1:730296716531:web:6f8f1647b838c68ef9bb86';

const getAppId = (environment: string) => {
  if (environment === 'acc') return appIdAcc;
  if (environment === 'dev') return appIdDev;
  if (environment === 'prod') return appIdProd;
  return appIdDev;
};

export function getRemoteConfigByEnvironment(environment: string) {
  const firebaseConfig = {
    apiKey: 'AIzaSyBiWXkQziPIpnOIZ9y-4ibLu4J1C7V9Pu0',
    authDomain: 'customer-extranet---bxl.firebaseapp.com',
    projectId: 'customer-extranet---bxl',
    storageBucket: 'customer-extranet---bxl.firebasestorage.app',
    messagingSenderId: '730296716531',
    appId: getAppId(environment),
  };

  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);

  remoteConfig.settings = {
    minimumFetchIntervalMillis: ONE_HOUR,
    fetchTimeoutMillis: ONE_MINUTE,
  };

  return remoteConfig;
}
